/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Audit_Invitation_ExpiredInputs */

const fr_account_audit_invitation_expired = /** @type {(inputs: Account_Audit_Invitation_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invitation expirée`)
};

/**

* @param {Account_Audit_Invitation_ExpiredInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const account_audit_invitation_expired = /** @type {((inputs?: Account_Audit_Invitation_ExpiredInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Audit_Invitation_ExpiredInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_account_audit_invitation_expired(inputs)
});